(() => {
    if (window.mbArticleSummaryInitialized) return;
    window.mbArticleSummaryInitialized = true;

    function initSummary(root = document) {
        const summaries = root.querySelectorAll('[data-article-summary]');

        summaries.forEach((summary) => {
            if (summary.dataset.summaryReady === 'true') return;

            const links = Array.from(summary.querySelectorAll('[data-article-summary-link]'));
            const items = links
                .map((link) => {
                    const targetId = link.getAttribute('data-target-id');
                    const target = targetId ? document.getElementById(targetId) : null;

                    if (!target) return null;
                    return { link, target };
                })
                .filter(Boolean);

            if (!items.length) return;

            const setActive = (activeId) => {
                items.forEach(({ link, target }) => {
                    const isActive = target.id === activeId;
                    link.classList.toggle('is-active', isActive);
                    if (isActive) {
                        link.setAttribute('aria-current', 'true');
                    } else {
                        link.removeAttribute('aria-current');
                    }
                });
            };

            let activeId = items[0].target.id;
            setActive(activeId);

            const observer = new IntersectionObserver(
                (entries) => {
                    const visibleEntries = entries
                        .filter((entry) => entry.isIntersecting)
                        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

                    if (!visibleEntries.length) return;

                    const nextActiveId = visibleEntries[0].target.id;
                    if (nextActiveId === activeId) return;

                    activeId = nextActiveId;
                    setActive(activeId);
                },
                {
                    root: null,
                    rootMargin: '-20% 0px -65% 0px',
                    threshold: [0, 0.1, 0.25, 0.5, 1],
                }
            );

            items.forEach(({ target, link }) => {
                observer.observe(target);
                link.addEventListener('click', () => {
                    activeId = target.id;
                    setActive(activeId);
                });
            });

            summary.dataset.summaryReady = 'true';
        });
    }

    document.addEventListener('DOMContentLoaded', () => initSummary());
    document.addEventListener('shopify:section:load', (event) => initSummary(event.target));
})();
